<script>
	import { onMount, onDestroy } from 'svelte';

	let canvas;
	let rafId;

	const W = 340,
		H = 340;
	const COL_BRIGHT = '#2491FF';
	const NUM_RINGS = 25;
	const FPS = 60;
	const TOTAL_FRAMES = 480;

	const rings = [];
	{
		const rxStart = 118.35,
			rxEnd = 19.17;
		const ryStart = 118.58,
			ryEnd = 155.57;
		for (let i = 0; i < NUM_RINGS; i++) {
			const t = i / (NUM_RINGS - 1);
			rings.push({
				rx: rxStart + (rxEnd - rxStart) * t,
				ry: ryStart + (ryEnd - ryStart) * t,
				opacity: 1.0 - t,
				rotOffset: (-i * 4.12 * Math.PI) / 180,
			});
		}
	}

	const CX = W / 2,
		CY = H / 2;

	const GROUP1_P = [
		{ t: 0, x: CX, y: CY },
		{ t: 120, x: CX, y: CY },
		{ t: 240, x: CX, y: CY },
		{ t: 360, x: CX, y: CY },
		{ t: 480, x: CX, y: CY },
	];

	const GROUP2_P = [
		{ t: 0, x: CX, y: CY },
		{ t: 120, x: CX + 9, y: CY + 11 },
		{ t: 240, x: CX + 9, y: CY + 8 },
		{ t: 360, x: CX, y: CY + 2 },
		{ t: 480, x: CX, y: CY },
	];

	function interpKF(kfs, frame) {
		for (let i = 0; i < kfs.length - 1; i++) {
			if (frame >= kfs[i].t && frame < kfs[i + 1].t) {
				const span = kfs[i + 1].t - kfs[i].t;
				const t = (frame - kfs[i].t) / span;
				const s = t * t * (3 - 2 * t);
				return {
					x: kfs[i].x + (kfs[i + 1].x - kfs[i].x) * s,
					y: kfs[i].y + (kfs[i + 1].y - kfs[i].y) * s,
				};
			}
		}
		return { x: kfs[kfs.length - 1].x, y: kfs[kfs.length - 1].y };
	}

	function drawRingGroup(ctx, frame, baseRotDeg, groupP, rotDir, groupAlpha) {
		const pos = interpKF(groupP, frame);
		const groupCX = pos.x;
		const groupCY = pos.y;
		const baseRotRad = ((baseRotDeg + rotDir * (frame / 480) * 360) * Math.PI) / 180;

		for (let i = 0; i < NUM_RINGS; i++) {
			const ring = rings[i];
			const rot = baseRotRad + ring.rotOffset;
			const alpha = ring.opacity * groupAlpha;
			if (alpha <= 0) continue;
			ctx.save();
			ctx.globalAlpha = alpha;
			ctx.translate(groupCX, groupCY);
			ctx.rotate(rot);
			ctx.beginPath();
			ctx.ellipse(0, 0, ring.rx, ring.ry, 0, 0, Math.PI * 2);
			ctx.strokeStyle = COL_BRIGHT;
			ctx.lineWidth = 1;
			ctx.stroke();
			ctx.restore();
		}
	}

	onMount(() => {
		const ctx = canvas.getContext('2d');
		let start = null;

		function animate(ts) {
			if (!start) start = ts;
			const elapsed = (ts - start) / 1000;
			const frame = (elapsed * FPS) % TOTAL_FRAMES;

			ctx.clearRect(0, 0, W, H);

			drawRingGroup(ctx, frame, 90.41, GROUP1_P, -1, 0.85);
			drawRingGroup(ctx, frame, -90.41, GROUP2_P, 1, 0.7);

			rafId = requestAnimationFrame(animate);
		}

		rafId = requestAnimationFrame(animate);
	});

	onDestroy(() => {
		if (rafId) cancelAnimationFrame(rafId);
	});
</script>

<canvas bind:this={canvas} width={W} height={H} />

<style>
	canvas {
		display: block;
		background: transparent;
	}
</style>
